import type { IconData } from '@stacksjs/iconify-core'

export const programmingModules: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M4.5 0h7v7h-7zM0 9h7v7H0zm16 0H9v7h7z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default programmingModules
